<!-- properties -->
<ng-container *ngIf="slideshow.assignment; else loading">
    <div id="properties">
        <properties-component 
            [(properties)]="slideshow.assignment.sites"
            [canEdit]="!slideshow.locked && userCanEdit"
            [slideshowLocked]="slideshow.locked"
            [showFacebook]="true"
            (propertiesChange)="slideshow.updateMessages()"
            [assignment]="slideshow.assignment"
            [(taxOptions)]="slideshow.paTaxonomyOptions">
        </properties-component>
        <div class="messages">
            <div *ngFor="let message of slideshow.messages"><mat-icon class="warning">error_outline</mat-icon> {{message}}</div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" id="common-meta">
        <tags-component
            fxFlex
            id="tags"
            [(termIds)]="slideshow.assignment.post_tag"
            [canEdit]="!slideshow.locked && permissionsService.userHasPermission(Permissions.EditTags)">
        </tags-component>
        <div fxFlex class="wysiwyg">
            <label>Meta Title</label>
            <richtext
                [(value)]="slideshow.assignment.metaTitle"
                (valueChange)="updateMetaTitle()"
                placeholder="Meta Title"
                *ngIf="!slideshow.locked && permissionsService.userHasPermission(Permissions.EditMetaTitle); else metaTitleEl"
                [removeButtons]="true">
            </richtext>
            <ng-template #metaTitleEl>
                <div [ngClass]="{faded: !slideshow.assignment.metaTitle}">{{slideshow.assignment.metaTitle ? slideshow.assignment.metaTitle : 'Meta Title'}}</div>
            </ng-template>
            <div class="word-count">{{slideshow.assignment.metaTitle.length}}/60</div>
        </div>
        <div fxFlex class="wysiwyg">
            <label>Meta Description</label>
            <richtext
                [(value)]="slideshow.assignment.metaDescription"
                (valueChange)="updateMetaDesc()"
                placeholder="Meta Description"
                *ngIf="!slideshow.locked && permissionsService.userHasPermission(Permissions.EditMetaDescription); else metaDescEl"
                [removeButtons]="true">
            </richtext>
            <ng-template #metaDescEl>
                <div [ngClass]="{faded: !slideshow.assignment.metaDescription}">{{slideshow.assignment.metaDescription ? slideshow.assignment.metaDescription : 'Meta Description'}}</div>
            </ng-template>
            <div class="word-count">{{slideshow.assignment.metaDescription.length}}/160</div>
        </div>
        <div fxFlex class="image">
            <label>Meta Image <span *ngIf="!slideshow.locked && permissionsService.userHasPermission(Permissions.EditMetaImage) && slideshow.assignment.metaImage != '';" (click)="resetImages()">Clear</span></label>
            <ng-container *ngIf="slideshow.assignment.metaImage != ''; else placeholder">
                <img [src]="slideshow.assignment.metaImage" (click)="openImages()">
            </ng-container>
            <ng-template #placeholder>
                <div class="placeholder" (click)="openImages()"><div><mat-icon>insert_photo</mat-icon></div></div>
            </ng-template>
        </div>
    </div>
    <div id="taxonomies">
        <h2 class="title">Taxonomies</h2>
        <div class="cf">
            <div class="taxonomy" *ngFor="let tax of taxonomyOptions; trackBy: utils.trackByIndex">
                <span class="title">{{tax.name}}</span>
                <div class="chips">
                    <button 
                        *ngFor="let option of tax.options"
                        [disabled]="slideshow.locked || !permissionsService.userHasPermission(Permissions.EditArticleTaxonomies)"
                        class="chip"
                        [ngClass]="{active: option.checked}"
                        (click)="selectOption(option, tax)">
                            {{option.name}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <msn-fields-component
        *ngIf="slideshow.assignment.msnFields && slideshow.assignment.msnFields.length > 0"
        [msnFields]="slideshow.assignment.msnFields">
    </msn-fields-component>
</ng-container>
<ng-template #loading>
    loading...
</ng-template>
